/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { GCLID_LOCAL_STORAGE_KEY } from '../constants'
import type { LocalStorage } from '../types/LocalStorage'

const VALID_GCLID_REGEX = /^[\w-]{1,250}$/

export const getGclidFromLocalStorage = (ls: LocalStorage) => {
  const value = ls.getx(GCLID_LOCAL_STORAGE_KEY, 7)
  if (value && VALID_GCLID_REGEX.test(value)) {
    return value
  }
}
